module.exports = __webpack_public_path__ + "img/imagem12.35f09d46.svg";